import { fontSize } from "@mui/system";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

function BulkUploadGuide({ sampelDownLoader }) {
  return (
    <div className="d-flex flex-column bulk-upload-guide-container">
      {/* ///machine-management/bulk-upload-guide */}
      <Link
        to="/default/machine-management/bulk-upload-guide"
        target="_blank"
        rel="noopener noreferrer"
        className="custom-link mb-3"
      >
        Visit this link for detail guide
      </Link>
      <h6>Important Field Constraints</h6>
      <ul>
        <li>
          <strong>Coolant Oil:</strong> Text (Format:{" "}
          <code>Brandname-Productname</code>)
        </li>
        <li>
          <strong>Hydraulic Oil:</strong> Text (Format:{" "}
          <code>Brandname-Productname</code>)
        </li>
        <li>
          <strong>Maintenance Oil:</strong> Text (Format:{" "}
          <code>Brandname-Productname</code>)
        </li>
      </ul>
      <div style={{ fontSize: "14px", fontWeight: "500" }}>
        <strong style={{ color: "red" }}>Note:</strong>{" "}
        <ul>
          <li>
            {" "}
            The Oils (Coolant Oil/Hydraulic Oil/Maintenance Oil) must follow the
            format <code>Brandname-Productname</code> with a hyphen{" "}
            <code>-</code> separating the brand and product names.
          </li>
          <li>Dont't use "/" in the Machine Number</li>
        </ul>
      </div>
      <p className="custom-link" onClick={sampelDownLoader}>
        <i className="fa-solid fa-cloud-download"></i> Download sample file
      </p>
    </div>
  );
}

export default BulkUploadGuide;
